import { CardComponentProps } from "@~/types/types";
import { CloseOutlined as Close24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext.tsx";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";

export function RemoveButton({
  product,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { title } = product;
  const dispatchEvent = useProductCardEvent();

  const clickHandler = () => {
    dispatchEvent(productCardEvents.removeProduct);
  };

  return (
    <IconButton
      icon={Close24PxOutlinedIcon}
      aria-label={`Remove ${title}`}
      data-component="pcl-RemoveButton"
      onClick={clickHandler}
      data-testid="remove-button"
      background="clear"
    />
  );
}
